import { render, staticRenderFns } from "./Olvido.vue?vue&type=template&id=4d947d63&"
import script from "./Olvido.vue?vue&type=script&lang=js&"
export * from "./Olvido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports